export default "__VITE_ASSET__828d7064__"